<template>
  <div class="logging-container">
    <CCard>
      <CCardHeader>
        <CRow>
          <CCol md="12" sm="12">
            <h1>{{ $t('LOGGING_LIST_PAGE_TITLE') }}</h1>
          </CCol>
        </CRow>
      </CCardHeader>
      <CCardBody>
        <SearchLoggingHeader :onSearch="onSearch" />
        <LoggingListTable :items="items" :getLoggings="getLoggings" :isAllowedDelete="isAllowedDelete" />
        <StakingPagination
          :limit="limit"
          :total="total"
          :activePage="activePage"
          @changePage="onChangePage"
          @changePageSize="onChangePageSize"
        />
      </CCardBody>
    </CCard>
  </div>
</template>
<script>
import moment from 'moment';
import LoggingListTable from '@/components/Logging/LoggingListTable';
import SearchLoggingHeader from '@/components/Logging/SearchLoggingHeader';
import StakingPagination from '@/components/StakingPagination';
import { endpoints, env, Constants } from '@/constants';
import responseHelper from '@/utils/response-helper';
import sessionStorageHelper from '@/utils/sessionStorage-helper';
import dateTimeHelper from '@/utils/datetime-helper';
import { mapState, mapActions, mapGetters } from 'vuex';
export default {
  name: 'LoggingList',
  components: {
    LoggingListTable,
    SearchLoggingHeader,
    StakingPagination,
  },
  data() {
    return {
      items: [],
      statuses: [],
      filterData: {},
      total: 0,
      limit: env.app.pageSize,
      activePage: 1,
      dateFormat: Constants.dateFormat,
      isAllowedDelete: false
    };
  },
  computed: {
    ...mapGetters(['userPermissions']),
    offset() {
      return (this.activePage - 1) * this.limit;
    },
    pages() {
      return Math.ceil(this.total / this.limit);
    },
  },
  async mounted() {
    this.checkPermissions();
    await Promise.all([this.getLoggings()]);
    this.isLoading = false;
  },
  methods: {
    checkPermissions() {
      if (this.userPermissions.length > 0) {
        this.userPermissions.forEach(item => {
          if (item.name === 'DELETE_LOGGING') {
            this.isAllowedDelete = true;
            return;
          }
        });
      }
    },
    async getLoggings(data) {
      data = data || {};
      this.filterData = {
        ...this.filterData,
        ...data,
      };
      const filterData = this.filterData;

      try {
        const params = {
          limit: this.limit,
          offset: this.offset,
          keyword: filterData.keyword,
          type: filterData.type,
          from_date: filterData.dateRange.startDate,
          to_date: dateTimeHelper.adjustToDate(filterData.dateRange.endDate),
          wallet_address: filterData.wallet_address,
        };
        const result = await this.$http.get(endpoints.getLoggings, { params });

        this.items = result.data.items || [];
        this.total = result.data.total;
      } catch (err) {
        this.$notify({
          group: 'notifications',
          type: 'error',
          title: this.$t('LOGGING_LIST_PAGE_TITLE_NOTIFY_ERROR'),
          text: responseHelper.getErrorMessage(err),
        });
      }
    },
    async onChangePage(page) {
      this.activePage = page;

      this.getLoggings();
    },
    async onChangePageSize(value) {
      this.limit = value;
      this.activePage = 1;

      this.getLoggings();
    },
    async onSearch(searchData) {
      const data = searchData;
      this.activePage = 1;

      this.getLoggings(data);
    },
  }
};
</script>
<style lang="scss">
.logging-container {
  padding: 0 24px;
  @media screen and (max-width: 1024px) {
    padding: 0 15px;
  }

  .card {
    > .card-header {
      border-bottom: none;
      padding-bottom: 0px;

      h1 {
        color: #657187;
        font-size: 18px;
        font-weight: 600;
        line-height: 34px;
        margin-bottom: 0px;
      }
    }
  }
}
</style>
